/*global sp, sprintf, searchHash, storage, myDataLayer, abTest318, analyticEventTracker */

var filter = {
    filteredCategories: [],
    data: {},
    serializedFormData: {},
    currentXhr: null,
    serverSideFilteringTimer: null,
    serverSide: typeof abTest318 !== 'undefined' && abTest318 === 2,
    showMoreEventInProgress: false,
    showMoreClickedCount: 0,
    topFilterElement: null,
    init: function(data, updateFilters) {
        filter.data = data;
        filter.filterText(false);

        if (updateFilters) {
            filter.backToTop();
            filter.resetFilter();
            filter.filtersApplied();
            filter.action();
            filter.removeInvalidTopFilters();
            filter.showMore();
        }
    },
    checkExtrasState: function() {
        let extrasEnabled = [];
        let extrasEnabledIds = {};

        $('.my-checkbox.extras').each(function() {
            const that = $(this);
            const extraId = that.data('id');

            if (that.is(':checked')) {
                //store data-id
                if (storage.get('extras-tooltip') === null) {
                    storage.save('extras-tooltip', 'show');
                    $('.session-tooltip').removeClass('d-none');
                }
                extrasEnabled.push(filter.serverSide ? that.data('name') : that.attr('name'));
                extrasEnabledIds[extraId] = 1;
            }
        });

        if (extrasEnabled.length === 0) {
            filter.updateCardPrice([], []);
        } else {
            filter.updateCardPrice(extrasEnabled, extrasEnabledIds);
        }
    },
    updateCardPrice: function(extras, extrasIds) {
        let carBoxContainer = $('#car-box-container');

        if (!filter.serverSide) {
            let sortType = $('.sort-by-list.active').data('type');

            carBoxContainer.addClass('loading');

            $('.car-box').each(function() {
                let card = $(this),
                    originalPrice = card.data('initial-total'),
                    cardMainPrice = card.find('.price-item-price-main'),
                    discount = '',
                    updatedDiscount = '',
                    formula = 0,
                    totalPrice,
                    newPriceString;

                if (card.data('promo') !== '') {
                    formula = originalPrice + (originalPrice * card.data('promo') / 100);
                    discount = sprintf(_d.s.currencyMask, formula.toFixed(2), _d.s.currencySign);
                }

                if (extras.length > 0) {
                    extras.forEach((extra) => {
                        const increaseTo = card.data(extra + '-price');
                        originalPrice = originalPrice + increaseTo;
                        formula = formula + increaseTo;
                    });

                    updatedDiscount = sprintf(_d.s.currencyMask, formula.toFixed(2), _d.s.currencySign);
                    const newPrice = sprintf(_d.s.currencyMask, originalPrice.toFixed(2), _d.s.currencySign);

                    newPriceString = (discount !== '' ? '<span>' + updatedDiscount + '</span> ' + newPrice : newPrice);
                    totalPrice = originalPrice.toFixed(2);
                } else {
                    newPriceString = (discount !== '' ? '<span>' + discount + '</span> ' + card.data('price-formatted') : card.data('price-formatted'));
                    totalPrice = card.data('initial-total');
                }

                if (discount !== '') {
                    cardMainPrice.html(newPriceString);
                } else {
                    cardMainPrice.text(newPriceString);
                }

                card.attr('data-total-price', totalPrice);
            });

            carBoxContainer.removeClass('loading');
            sp.orderBy(sortType, carBoxContainer, false, false);
        }

        $.postJSON(_d.url.search.extras, {
            guid: carBoxContainer.data('guid'),
            data: extrasIds
        });
    },
    action: function() {
        const waitTime = 800;

        $('#search-filter-body').on('change', 'input', function() {
            var input = $(this),
                categories = input.parents('.flt-type'),
                opts = input.parents('.flt-opts'),
                inputType = (input.prop('type') === 'checkbox' ? 'checkbox' : 'radio'),
                category = input.data('category'),
                removeFilter = $('.remove-filter'),
                label = $('label[for="' + input.attr('id') + '"]'),
                labelName = (typeof label.data('eventLabel') !== 'undefined' ? label.data('eventLabel') : 'unknown'),
                actionName = (typeof label.data('eventAction') !== 'undefined' ? label.data('eventAction') : 'unknown');

            let analyticsPostData = {
                eventName: 'Filter_Selected',
                attributes: {
                    'attributeFilterName': actionName + ' - ' + labelName
                }
            };

            opts.addClass('filter');

            if (input.hasClass('extras')) {
                filter.checkExtrasState();
            }

            if (filter.serverSide) {
                filter.resetPaging();
            }

            if (inputType === 'checkbox' && categories.find('[type=checkbox]:checked').length > 0) {
                categories.find('.flt-head').addClass('selected');

                if (filter.filteredCategories.indexOf(category) === -1) {
                    filter.filteredCategories.push(category);
                }

                if (input.is(':checked')) {
                    if (category === 'new-car-groups') {
                        if ($('.filter-list .disclaimer').length === 0) {
                            $('.filter-list').append('<span class="disclaimer">Want to use other filters? Turn this one off first.</span>');
                        }
                        $('.filter-list .disclaimer').append('<a href="javascript:void(0);" class="remove-filter" data-category="' + category + '" data-value="' + input.val() + '">' + input.next().data('text') + '</a>');
                    } else {
                        $('.filter-list').append('<a href="javascript:void(0);" class="remove-filter" data-category="' + category + '" data-value="' + input.val() + '">' + input.next().data('text') + '</a>');
                    }
                    $('.filters-applied').show();
                } else {
                    filter.removeCategoryFromFilteredCategories(category);
                }
            } else {
                categories.find('.flt-head').removeClass('selected');
                filter.removeCategoryFromFilteredCategories(category);
            }

            filter.formData();

            if (inputType === 'checkbox' && !input.is(':checked')) {
                analyticsPostData.eventName = 'Filter_Unselected';

                if ($('.new-car-top-filters').length) {
                    if (category === 'new-car-groups') {
                        $('.new-filters .disclaimer').remove();
                    }
                }

                if (removeFilter.length > 0) {
                    removeFilter.each(function() {
                        var that = $(this);
                        if (that.data('category') === category && that.data('value').toString() === input.val().toString()) {
                            that.remove();
                        }
                    });
                }
            }

            if (filter.serverSide) {
                if (filter.serverSideFilteringTimer) {
                    clearTimeout(filter.serverSideFilteringTimer);
                }

                $('#car-box-container').addClass('loading');

                filter.serverSideFilteringTimer = setTimeout(function() {
                    filter.update();
                    $('#offset').val(0);
                }, waitTime);

            } else {
                filter.update();
            }

            filter.removeAllFilters();

            opts.removeClass('filter');
            analyticEventTracker.trackEvent(analyticsPostData);
        });

        $('.top-filter-label').on('click', function(e) {
            /* this logic is only for real user clicks */
            if (!e.originalEvent) {
                return;
            }

            const that = $(this);
            const input = that.siblings('input');
            const shortcut = that.data('shortcut');

            if (input.hasClass('loading') || input.hasClass('disabled')) {
                return false;
            }

            setTimeout(function() {
                const checkbox = $(`input[data-shortcut="${shortcut}"]`);

                checkbox.closest('.flt-opts').addClass('opened');
                checkbox.trigger('click');
            }, 100);
        });

        $('#extras-tooltip').on('click', function(e) {
            e.preventDefault();
            $('.session-tooltip').addClass('d-none');
        });

        $('#filter-button-reset').on('click', function(e) {
            e.preventDefault();
            filter.filteredCategories = [];
            $('.car-box').removeClass('filtered-out').addClass('filtered');
            $('.new-filters .disclaimer').remove();
            $('.new-car-top-filters .item').removeClass('active');
            $('.remove-filter').remove();
            $('.filters-applied').hide();
            $('.clear-filter-group').each(function() {
                $(this).removeClass('active');
            });
            $('#search-filter')[0].reset();
            filter.filterText(true);
            filter.closeFilter();
        });

        $('.my-checkbox.car-groups').on('click', function() {
            if ($(this).is(':checked')) {
                $('.car-groups-item[data-id='+$(this).attr('id')+']').addClass('triggered').trigger('click');
            } else {
                $('.car-groups-remove[data-id='+$(this).attr('id')+']').addClass('triggered').trigger('click');
            }
        });

        $('body').on('click', '.show-more-cars', function(e) {
            e.preventDefault();

            if (!filter.showMoreEventInProgress) {
                filter.showMoreClickedCount++;

                let postData = {
                    eventName: 'ShowMore_Tap',
                    attributes: {
                        'attributeTimesClicked': filter.showMoreClickedCount
                    }
                };

                analyticEventTracker.trackEvent(postData);
                filter.showMoreEventInProgress = true;

                setTimeout(function() {
                    filter.showMoreEventInProgress = false;
                }, 1000);
            }

            var that = $(this);

            if (that.hasClass('loading')) {
                return false;
            }

            that.addClass('loading');

            if (filter.serverSide) {
                const pageHandler = $('#page');
                let page = parseInt(pageHandler.val());
                pageHandler.val(page + 1);
                filter.formData();
                filter.filterRequest();
            } else {

                if ($('.car-box.filtered').length === 0) {
                    $('.car-box.no-show:lt(' + sp.search.limit + ')').removeClass('no-show');

                    if ($('.car-box.no-show').length === 0) {
                        that.hide();
                    }
                } else {
                    $('.car-box.filtered.no-show:lt(' + sp.search.limit + ')').removeClass('no-show');

                    if ($('.car-box.filtered.no-show').length === 0) {
                        that.hide();
                    }
                }

                try {
                    let displayedCars = sp.countDisplayedCars();
                    let productBatches = sp.splitIntoBatches(displayedCars);
                    sp.updateCurrentImpressionViews(displayedCars);

                    productBatches.forEach(function(productBatch) {
                        let eventData = sp.getProductBatch(productBatch);
                        if (eventData.length) {
                            if (filter.filteredCategories.length) {
                                myDataLayer.sendImpressionEvent(eventData, 'impressionFilter');
                            } else {
                                myDataLayer.sendImpressionEvent(eventData, 'impressionView');
                            }
                        }
                    });
                } catch (err) {}
            }

            that.removeClass('loading').blur();
        });

        if ($('.new-car-top-filters').length) {
            $('.new-car-top-filters .item').each(function() {
                var dataId = $(this).attr('data-id');
                if ($('#' + dataId).length === 0) {
                    $(this).addClass('disabled');
                }
            });
        }

        $('.new-car-top-filters .item').on('click', function(e) {
            e.preventDefault();

            const that = $(this);

            const isDisabled = that.hasClass('disabled');
            if (isDisabled) {
                return;
            }

            const isActive = that.hasClass('active');
            const previousActive = $('.new-car-top-filters .item.active');
            const previousFilterId = previousActive.data('id');

            $('.new-car-top-filters .item').removeClass('active');

            if (previousFilterId && !isActive) {
                $('#' + previousFilterId).trigger('click');
            }

            const filterId = that.data('id');
            const formattedFilterId = filterId.replace('new-car-groups-', '');

            if (isActive) {
                that.removeClass('active');
                $('#' + filterId).trigger('click');
                return;
            }

            that.addClass('active loading');

            let filters = '';
            let filterIds = [];
            let sortingCriteria = '';

            switch (formattedFilterId) {
                case 'family':
                    filterIds = [
                        '#number-of-seats-seats-5',
                        '#number-of-seats-seats-6-more',
                        '#location-type-3',
                        '#location-type-5',
                        '#transmission-type-transmission-a',
                        '#extra3-true-3',
                        '#extra5-true-5',
                        '#extra4-true-4',
                        '#car-groups-suv',
                        '#car-groups-vans',
                        '#car-groups-estate',
                        '#car-groups-large',
                        '#mileage-18',
                        '#air-conditioning-air-conditioning-y'
                    ];
                    sortingCriteria = 'price';
                    break;
                case 'solo':
                    filterIds = [
                        '#number-of-seats-seats-2',
                        '#number-of-seats-seats-4',
                        '#air-conditioning-air-conditioning-y',
                        '#transmission-type-transmission-a',
                        '#car-groups-small',
                        '#car-groups-medium',
                        '#car-groups-convertibles'
                    ];
                    sortingCriteria = 'supplierRating';
                    break;
                case 'business':
                    filterIds = [
                        '#car-groups-small',
                        '#car-groups-medium',
                        '#air-conditioning-air-conditioning-y',
                        '#transmission-type-transmission-a',
                        '#pt-2',
                        '#location-type-5'
                    ];
                    sortingCriteria = 'price';
                    break;
                case 'storage':
                    filterIds = [
                        '#car-groups-estate',
                        '#car-groups-vans',
                        '#mileage-18'
                    ];
                    sortingCriteria = 'price';
                    break;
                case 'daily':
                    filterIds = [
                        '#car-groups-small',
                        '#transmission-type-transmission-a',
                        '#special-offers-instant-confirmation',
                        '#mileage-18'
                    ];
                    sortingCriteria = 'price';
                    break;
                default:
                    break;
            }

            filter.topFilterElement = that;

            setTimeout(function() {
                $('.sort-by-list[data-attribute-sorting-criteria="' + sortingCriteria + '"]').trigger('click');
                $('#' + filterId).trigger('click');
            }, 200);

            filters = filter.getJbtdFilterTexts(filterIds);

            const eventData = {
                eventName: 'Jbtd_Filter_Selected',
                attributes: {
                    'attributePageSource': _d.page,
                    'attributeJbtdFilters': formattedFilterId.charAt(0).toUpperCase() + formattedFilterId.slice(1) + ': ' + filters
                }
            };

            analyticEventTracker.trackEvent(eventData);
        });
    },
    getJbtdFilterTexts: function(filterIds) {
        const filterTexts = filterIds.map(id => {
            const element = $(id);
            return $(`label[for="${element.attr('id')}"]`).attr('data-text') || '';
        }).filter(text => text.trim() !== '')
            .join(', ');

        return filterTexts.trim().replace(/(^, )|(, $)/g, '');
    },
    closeFilter: function() {
        $('#searchFilterModal').modal('hide');
    },
    removeCategoryFromFilteredCategories: function(category) {
        const categoryIndex = filter.filteredCategories.indexOf(category);
        const categoryCountInAppliedFilters = $('.remove-filter[data-category="' + category + '"]').length;

        if (categoryIndex !== -1 && categoryCountInAppliedFilters === 0) {
            filter.filteredCategories.splice(categoryIndex, 1);
        }
    },
    getSelectors: function() {
        var checkedFilters = [];
        $('.clear-filter-group').removeClass('active');
        $('.flt-group').each(function() {
            var that = $(this),
                groupHead = '',
                filterGroupChecked = $('input:checked', that);

            if (filterGroupChecked.length > 0) {
                let dataAttr = [];
                filterGroupChecked.each(function(i) {
                    const that = $(this);
                    dataAttr[i] = '[data-' + (filter.serverSide ? that.data('name') : that.attr('name')) + '="' + that.val() + '"]';
                });

                checkedFilters.push(dataAttr.join(','));

                if (that.hasClass('multiple')) {
                    groupHead = that.parent().prev();
                } else {
                    groupHead = that.prev();
                }

                groupHead.find('.clear-filter-group').addClass('active');
            }
        });

        return checkedFilters;
    },
    update: function() {
        var carItem = $('.car-box'),
            checkedFilters = filter.getSelectors(),
            checkedResults = filter.filterResults(carItem, checkedFilters);

        if (filter.serverSide) {
            filter.filterRequest();
        } else {
            carItem.addClass('filtered-out').removeClass('filtered');

            if (sp.search.paging) {
                checkedResults.removeClass('filtered-out').addClass('filtered no-show');
                $('.car-box.filtered:lt(' + sp.search.limit + ')').removeClass('no-show');
            } else {
                checkedResults.removeClass('filtered-out').addClass('filtered');
            }

            filter.filterText(true);

            if (filter.topFilterElement) {
                $('.new-car-top-filters .item').removeClass('loading');
            }

            try {
                sp.resetCurrentImpressionViews();
                let displayedCars = sp.countDisplayedCars();
                let productBatches = sp.splitIntoBatches(displayedCars);
                sp.updateCurrentImpressionViews(displayedCars);

                productBatches.forEach(function(productBatch) {
                    myDataLayer.sendImpressionEvent(sp.getProductBatch(productBatch), 'impressionFilter');
                });
            } catch (err) {}
        }

        filter.saveInStorage();
    },
    filterResults: function($results, filters) {
        for (var i in filters) {
            if (Object.prototype.hasOwnProperty.call(filters, i)) {
                $results = $results.filter(filters[i]);
            }
        }

        return $results;
    },
    activeFilters: function() {
        var filterCarGroups = [],
            filterFuelPolicy = [],
            filterLocation = [],
            filterLocationType = [],
            filterExtras = [],
            filterRating = [],
            filterPickUp = [],
            filterSupplier = [],
            filterMileage = [],
            filterSpecialOffers = [],
            filterAirConditioning = [],
            filterTransmissionType = [],
            filterFuelType = [],
            filterDoors = [],
            filterWheelDrive = [],
            filterMapLocations = [],
            filterSeats = [],
            filterDeposit = [],
            filterPaymentType = [],
            firstCategory = filter.filteredCategories[0],
            filterNewCarGroups = [];

        $('.filtered').each(function() {
            var dataFullList = $(this).data();

            $.each(dataFullList, function(index, value) {
                // Car groups
                if (index === 'carGroupsSmall' && filterCarGroups.indexOf(value) === -1) {
                    filterCarGroups.push(value);
                }

                if (index === 'carGroupsMedium' && filterCarGroups.indexOf(value) === -1) {
                    filterCarGroups.push(value);
                }

                if (index === 'carGroupsLarge' && filterCarGroups.indexOf(value) === -1) {
                    filterCarGroups.push(value);
                }

                if (index === 'carGroupsSuv' && filterCarGroups.indexOf(value) === -1) {
                    filterCarGroups.push(value);
                }

                if (index === 'carGroupsEstate' && filterCarGroups.indexOf(value) === -1) {
                    filterCarGroups.push(value);
                }

                if (index === 'carGroupsConvertibles' && filterCarGroups.indexOf(value) === -1) {
                    filterCarGroups.push(value);
                }

                if (index === 'carGroupsVans' && filterCarGroups.indexOf(value) === -1) {
                    filterCarGroups.push(value);
                }

                if (index === 'carGroupsPremium' && filterCarGroups.indexOf(value) === -1) {
                    filterCarGroups.push(value);
                }

                // New Car groups
                if (index === 'newCarGroupsFamily' && filterNewCarGroups.indexOf(value) === -1) {
                    filterNewCarGroups.push(value);
                }

                if (index === 'newCarGroupsSolo' && filterNewCarGroups.indexOf(value) === -1) {
                    filterNewCarGroups.push(value);
                }

                if (index === 'newCarGroupsBusiness' && filterNewCarGroups.indexOf(value) === -1) {
                    filterNewCarGroups.push(value);
                }

                if (index === 'newCarGroupsStorage' && filterNewCarGroups.indexOf(value) === -1) {
                    filterNewCarGroups.push(value);
                }

                if (index === 'newCarGroupsDaily' && filterNewCarGroups.indexOf(value) === -1) {
                    filterNewCarGroups.push(value);
                }

                // Car specifications
                if (index === 'transmissionType' && filterTransmissionType.indexOf(value) === -1) {
                    filterTransmissionType.push(value);
                }

                if (index === 'airConditioning' && filterAirConditioning.indexOf(value) === -1) {
                    filterAirConditioning.push(value);
                }

                if (index === 'fuelType' && filterFuelType.indexOf(value) === -1) {
                    filterFuelType.push(value);
                }

                if (index === 'doors' && filterDoors.indexOf(value) === -1) {
                    filterDoors.push(value);
                }

                if (index === 'wheelDrive' && filterWheelDrive.indexOf(value) === -1) {
                    filterWheelDrive.push(value);
                }

                // Supplier
                if (index === 'supplier' && filterSupplier.indexOf(value) === -1) {
                    filterSupplier.push(value);
                }

                // Map Locations
                if (index === 'mapLocations' && filterMapLocations.indexOf(value) === -1) {
                    filterMapLocations.push(value);
                }

                // Rating
                if (index === 'ratingExceptional' || index === 'ratingExcellent' || index === 'ratingVeryGood' || index === 'ratingGood' || index === 'ratingAcceptable') {
                    if (filterRating.indexOf(value) === -1) {
                        filterRating.push(value);
                    }
                }

                // Extras
                if (index === 'extra2' || index === 'extra3' || index === 'extra4' || index === 'extra5' || index === 'extra6' || index === 'extra10') {
                    if (filterExtras.indexOf(value) === -1) {
                        filterExtras.push(value);
                    }
                }

                // Payment at pickup
                if (index === 'pickupDebit' || index === 'pickupCredit') {
                    if (filterPickUp.indexOf(value) === -1) {
                        filterPickUp.push(value);
                    }
                }

                // Locations
                if (index === 'location' && filterLocation.indexOf(value) === -1) {
                    filterLocation.push(value);
                }

                // Location Type
                if (index === 'locationType' && filterLocationType.indexOf(value) === -1) {
                    filterLocationType.push(value);
                }

                // Fuel Policy
                if (index === 'fuelPolicy' && filterFuelPolicy.indexOf(value) === -1) {
                    filterFuelPolicy.push(value);
                }

                // Number of seats
                if (index === 'numberOfSeats' && filterSeats.indexOf(value) === -1) {
                    filterSeats.push(value);
                }

                // Deposit
                if (index === 'depositGroup-3' || index === 'depositGroup-2' || index === 'depositGroup-1' || index === 'depositGroup-0') {
                    if (filterDeposit.indexOf(value) === -1) {
                        filterDeposit.push(value);
                    }
                }

                // Payment type
                if (index === 'paymentType' && filterPaymentType.indexOf(value) === -1) {
                    filterPaymentType.push(value);
                }

                // Mileage
                if (index === 'mileage' && filterMileage.indexOf(value) === -1) {
                    filterMileage.push(value);
                }

                // Special offers
                if (index === 'seasonalPromo' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'isExact' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'instantConfirmation' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'gps' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'additionalDriver' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'zeroDeposit' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'onlineCheckIn' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'zeroEmission' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'winterTires' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'discoverChoice' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'springPromo' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }

                if (index === 'cug' && filterSpecialOffers.indexOf(value) === -1) {
                    filterSpecialOffers.push(value);
                }
            });
        });

        $('.filtering-event').removeClass('disabled');

        $('.flt-group input').each(function() {
            var that = $(this),
                category = that.data('category');

            if (filter.filteredCategories.indexOf(category) === -1) {
                that.prop('disabled', true);
            }
        });

        if (typeof firstCategory !== 'undefined') {
            $('.filter-' + firstCategory).each(function() {
                $(this).prev().prop('disabled', false);
            });
        }

        if (filterCarGroups.length > 0 && filter.filteredCategories.indexOf('car-groups') === -1) {
            $('.filter-car-groups').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev(),
                    id = checkbox.attr('id');

                if (filterCarGroups.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                    $('.car-groups-item[data-id=' + id + ']').addClass('disabled');
                } else {
                    checkbox.prop('disabled', false);
                    $('.car-groups-item[data-id=' + id + ']').removeClass('disabled');
                }
            });
        }

        if ($('.filter-new-car-groups').length > 0) {
            $('.filter-new-car-groups').each(function() {
                let checkbox = $(this).prev();
                checkbox.prop('disabled', false);
            });
        }

        if (filterRating.length > 0 && filter.filteredCategories.indexOf('rating') === -1) {
            $('.filter-rating').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterRating.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterMapLocations.length > 0 && filter.filteredCategories.indexOf('map-locations') === -1) {
            $('.filter-map-locations').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterMapLocations.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterAirConditioning.length > 0 && filter.filteredCategories.indexOf('air-conditioning') === -1) {
            $('.filter-air-conditioning').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterAirConditioning.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterTransmissionType.length > 0 && filter.filteredCategories.indexOf('transmission-type') === -1) {
            $('.filter-transmission-type').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterTransmissionType.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterFuelType.length > 0 && filter.filteredCategories.indexOf('fuel-type') === -1) {
            $('.filter-fuel-type').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterFuelType.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterDoors.length > 0 && filter.filteredCategories.indexOf('doors') === -1) {
            $('.filter-doors').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterDoors.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterWheelDrive.length > 0 && filter.filteredCategories.indexOf('wheel-drive') === -1) {
            $('.filter-wheel-drive').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterWheelDrive.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterSupplier.length > 0 && filter.filteredCategories.indexOf('supplier') === -1) {
            $('.filter-supplier').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterSupplier.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterPickUp.length > 0 && filter.filteredCategories.indexOf('payment-at-pickup') === -1) {
            $('.filter-payment-at-pickup').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterPickUp.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterExtras.length > 0) {
            $('.filter-extras').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterExtras.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterLocation.length > 0 && filter.filteredCategories.indexOf('location') === -1) {
            $('.filter-location').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterLocation.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterLocationType.length > 0 && filter.filteredCategories.indexOf('location-type') === -1) {
            $('.filter-location-type').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterLocationType.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterFuelPolicy.length > 0 && filter.filteredCategories.indexOf('fuel-policy') === -1) {
            $('.filter-fuel-policy').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterFuelPolicy.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterSeats.length > 0 && filter.filteredCategories.indexOf('number-of-seats') === -1) {
            $('.filter-number-of-seats').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterSeats.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterDeposit.length > 0 && filter.filteredCategories.indexOf('deposit') === -1) {
            $('.filter-deposit').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterDeposit.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterMileage.length > 0 && filter.filteredCategories.indexOf('mileage') === -1) {
            $('.filter-mileage').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterMileage.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterSpecialOffers.length > 0) {
            $('.filter-special-offers').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterSpecialOffers.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        if (filterPaymentType.length > 0 && filter.filteredCategories.indexOf('payment-type') === -1) {
            $('.filter-payment-type').each(function() {
                var val = $(this).data('value'),
                    checkbox = $(this).prev();

                if (filterPaymentType.indexOf(val) === -1) {
                    checkbox.prop('disabled', true);
                } else {
                    checkbox.prop('disabled', false);
                }
            });
        }

        $('.top-filter-option').each(function() {
            const that = $(this);
            const shortcut = that.find('label').data('shortcut');
            const checkbox = that.find('input');
            const realCheckbox = $(`input[data-shortcut="${shortcut}"]`);

            const isDisabled = realCheckbox.prop('disabled');
            const isChecked = realCheckbox.is(':checked');

            checkbox.prop('disabled', isDisabled);
            checkbox.prop('checked', isChecked);
        });
    },
    filterText: function(dynamic) {
        const noCarsAvailable = $('.no-cars-available');
        const otherCars = $('.other-cars');
        const fcBox = $('.fc-box');
        const cars = $('#cars');
        const totalCars = filter.data.cnt;
        const filterApplied = $('.filters-applied.bottom');
        const zeroElements = $('.showing-cars-block');
        const showMore = $('.show-more-cars');
        const hiddenCars = $('.car-box.filtered-out').length;
        const showingCars = filter.serverSide ? filter.data.filteredCnt : totalCars - hiddenCars;

        $('.showing-cars').text(showingCars);
        $('.total-cars').text(totalCars);

        filter.toggleUpsellCarousel(hiddenCars === 0);

        if ($('.selected-car-box:visible').length > 0) {
            otherCars.show();
        } else {
            otherCars.hide();
        }

        if (showingCars !== totalCars) {
            fcBox.hide();
        } else {
            fcBox.show();
        }

        if ($('.filters-applied:visible').length > 0) {
            if (showingCars > 1) {
                filterApplied.show();
            } else {
                filterApplied.hide();
            }
        }

        if (showingCars === 0) {
            cars.hide();
            showMore.hide();
            noCarsAvailable.removeClass('hide');
            zeroElements.addClass('zero');

            $('html, body').stop().animate({
                scrollTop: 0
            }, 500);
        } else {
            cars.show();
            noCarsAvailable.addClass('hide');
            zeroElements.removeClass('zero');
        }

        if (showingCars < 3) {
            $('html, body').stop().animate({
                scrollTop: 0
            }, 500);
        }

        if (filter.serverSide) {
            setTimeout(function() {
                if ($('.car-box').length >= showingCars) {
                    showMore.hide();
                } else {
                    showMore.show();
                }
            }, 0);
        } else if (showingCars > sp.search.limit) {
            showMore.show();
        } else {
            showMore.hide();
        }

        $(window).scroll();
        $('.filter').removeClass('filter');

        if (dynamic) {
            filter.activeFilters();
        }
    },
    resetFilter: function() {
        var body = $('body');

        body.on('click', '.clear-filter-group', function(e) {
            e.stopPropagation();
            e.preventDefault();
            var that = $(this),
                category = that.data('category'),
                categoryIndex = -1;

            if (that.hasClass('label')) {
                return false;
            }

            if (category.indexOf(',') > 0) {
                var categories = category.split(',');

                for (var i in categories) {
                    if (Object.prototype.hasOwnProperty.call(categories, i)) {
                        categoryIndex = filter.filteredCategories.indexOf(categories[i]);

                        if (categoryIndex !== -1) {
                            filter.filteredCategories.splice(categoryIndex, 1);
                        }

                        $('.remove-filter[data-category="' + categories[i] + '"]').remove();
                    }
                }
            } else {
                categoryIndex = filter.filteredCategories.indexOf(category);

                if (categoryIndex !== -1) {
                    filter.filteredCategories.splice(categoryIndex, 1);
                }

                $('.remove-filter[data-category="' + category + '"]').remove();
            }

            $(this).parents('.flt-head').removeClass('selected').next().find('input').prop({'checked': false, 'disabled': false});
            filter.formData();
            filter.update();
            filter.removeAllFilters();
        });

        body.on('click', '.clear-filter', function(e) {
            e.preventDefault();
            filter.filteredCategories = [];
            $(this).removeClass('show');
            $('#search-filter')[0].reset();

            $('.new-filters .disclaimer').remove();
            $('.remove-filter').remove();
            $('.filters-applied').hide();

            $('.clear-filter-group').each(function() {
                $(this).removeClass('active').parents('.flt-head').next().find('input').prop({'checked': false, 'disabled': false});
            });
            filter.formData();
            filter.saveInStorage();

            if (filter.serverSide) {
                setTimeout( function() {
                    filter.resetPaging();
                    filter.filterRequest();
                }, 0);
            } else {
                if (sp.search.paging) {
                    $('.car-box').removeClass('filtered-out').addClass('filtered no-show');
                    $('.car-box.filtered:lt(' + sp.search.limit + ')').removeClass('no-show');
                } else {
                    $('.car-box').removeClass('filtered-out').addClass('filtered');
                }

                filter.filterText(true);
                filter.carGroupsUncheck('all');
            }

            let analyticsPostData = {
                eventName: 'Filter_Unselected',
                attributes: {
                    'attributeFilterName': 'Remove all'
                }
            };

            analyticEventTracker.trackEvent(analyticsPostData);
        });
    },
    removeAllFilters: function() {
        var removeAllFilter = $('.remove-all-filters'),
            clearFilter = $('.clear-filter');

        if ($('.remove-filter').length === 0) {
            $('.new-car-top-filters .item').removeClass('active');
            $('.filters-applied').hide();
            clearFilter.removeClass('show');
        } else {
            clearFilter.addClass('show');
        }

        if ($('.remove-filter').length > 2) {
            $('.new-filters .filter-list .disclaimer').addClass('mb-16');
            removeAllFilter.show();
        } else {
            $('.new-filters .filter-list .disclaimer').removeClass('mb-16');
            removeAllFilter.hide();
        }
    },
    backToTop: function() {
        var returnToTop = $('#return-to-top'),
            offset = 1000,
            offsetOpacity = 2000,
            scrollTopDuration = 500;

        $(window).scroll(function() {
            $(this).scrollTop() > offset ? returnToTop.addClass('cd-is-visible') : returnToTop.removeClass('cd-is-visible cd-fade-out');

            if ($(this).scrollTop() > offsetOpacity) {
                returnToTop.addClass('cd-fade-out');
            }
        });

        returnToTop.click(function(e) {
            e.preventDefault();

            $('body,html').animate({
                scrollTop: 0
            }, scrollTopDuration);
        });
    },
    filtersApplied: function() {
        $('.filter-list').on('click', '.remove-filter', function(e) {
            e.preventDefault();
            var that = $(this),
                category = that.data('category'),
                val = that.data('value');

            $('.remove-filter[data-category="' + category + '"][data-value="' + val + '"]').remove();
            $('input[data-category="' + category + '"][value="' + val + '"]').prop('checked', false).change();
            $('.car-groups-item[data-id="car-groups-' + val + '"]').removeClass('selected triggered');
            $('.new-car-top-filters .item[data-id="new-car-groups-' + val + '"]').removeClass('active');
            filter.carGroupsUncheck('item');
            filter.formData();
        });

        $('.car-top-filter-item').on('mouseup', function() {
            const that = $(this);
            const category = that.data('category');
            const val = that.data('value');

            if (!that.hasClass('selected')) {
                return;
            }

            setTimeout(() => {
                $(`.remove-filter[data-category="${category}"][data-value="${val}"]`).click();
            });
        });

        $('.remove-all-filters').on('click', function(e) {
            e.preventDefault();
            $('.clear-filter').click();
            filter.carGroupsUncheck('all');
            $('.new-car-top-filters .item').removeClass('active');
        });
    },
    carGroupsUncheck: function(mode) {
        var typeItems = $('.car-groups-item');

        if (mode === 'all') {
            typeItems.removeClass('selected triggered').addClass('init');
        } else if (!typeItems.hasClass('selected')) {
            typeItems.addClass('init');
        }
    },
    saveInStorage: function() {
        storage.save(sp.search.storagePrefix + searchHash, $('#search-filter').serializeArray());
    },
    filterRequest: function() {
        filter.currentXhr && filter.currentXhr.readyState !== 4 && filter.currentXhr.abort(); // clear previous request

        const carBoxContainer = $('#car-box-container');
        carBoxContainer.addClass('loading');

        filter.currentXhr = $.ajax({
            url: sp.search.url,
            type: 'POST',
            data: filter.serializedFormData,
            dataType: 'json',
            crossDomain: true,
            success: function(data) {
                filter.data = data;
                sp.search.parseData(data, false);
                carBoxContainer.removeClass('loading');
                filter.currentXhr = null;
            },
            error: function() {
                carBoxContainer.removeClass('loading');
            }
        });
    },
    resetPaging: function() {
        $('#page').val(1);
    },
    filterGroupUpdates: function() {
        $('.flt-group').each(function() {
            let that = $(this);
            let groupHead = '';
            let filterGroupChecked = $('input:checked', that);

            if (filterGroupChecked.length > 0) {
                filterGroupChecked.prop('disabled', false);

                if (that.hasClass('multiple')) {
                    groupHead = that.parent().prev();
                } else {
                    groupHead = that.prev();
                }

                groupHead.find('.clear-filter-group').addClass('active');
            }
        });
    },
    carGroupsUpdates: function() {
        if ($('.car-groups-item.selected').length > 0 ) {
            $('.car-groups-item').removeClass('init');
        }
    },
    formData: function() {
        let firstCategory = (typeof filter.filteredCategories[0] !== 'undefined' ? filter.filteredCategories[0] : 'none');
        $('#firstCategory').val(firstCategory);

        filter.serializedFormData = $('#search-filter').serialize();
    },
    showMore: function() {
        $('.flt-type').not('.hide').find('.flt-opts').each(function() {
            const that = $(this);
            const wrapper = $('.flt-body-new');
            const filterOptions = that.find('.filter-option');
            const showMoreText = wrapper.data('show-more');
            const showLessText = wrapper.data('show-less');

            if (
                filterOptions.length < 5
                || that.attr('id') === 'filter-supplier'
                || that.attr('id') === 'top-filters'
            ) {
                return;
            }

            filterOptions.filter(':gt(2)').hide();
            filterOptions.last().after(`
                <a href="#" class="show-more-filters text-blue-600-new text-medium text-14">
                    ${ showMoreText }
                </a>
            `);

            that.on('click', '.show-more-filters', function(e) {
                e.preventDefault();
                const that = $(this);
                const isOpened = that.hasClass('opened');

                filterOptions.slice(3).toggle(!isOpened);

                that
                    .toggleClass('opened')
                    .text(isOpened ? showMoreText : showLessText);
            });
        });
    },
    removeInvalidTopFilters: function() {
        $('.top-filter-option').each(function() {
            const that = $(this);
            const shortcut = that.find('label').data('shortcut');
            const checkbox = $(`input[data-shortcut="${shortcut}"]`);

            if (checkbox.length === 0) {
                that.remove();
            }
        });
    },
    toggleUpsellCarousel: function(show) {
        const upsellCarousel = $('.upsell-carousel');

        if (upsellCarousel.length > 0) {
            show ? upsellCarousel.show() : upsellCarousel.hide();
        }
    }
};
